import { Pipe, PipeTransform } from '@angular/core';

import { FeatureTypes, isFeatureEnabled } from '../feature/feature';

@Pipe({
    name: 'feature'
})
export class FeaturePipe implements PipeTransform {
    transform(feature: FeatureTypes): boolean {
        return isFeatureEnabled(feature);
    }
}
